import React from 'react'
import { withRouter } from 'react-router-dom'

import Menu from './Menu'
import logOut from '../../actions/logOut'

class MenuContainer extends React.Component {

  _showRules = () => {
    this.props.history.push('/rules')
  }

  _showHome = () => {
    this.props.history.push('/')
  }

  _logOut = () => {
    logOut()
    this.props.history.push('/')
  }

  render() {
    return <Menu
      showRules={this._showRules}
      goBack={this._showHome}
      logOut={this._logOut}
      {...this.props}
    />
  }

}

// export default MenuContainer
export default withRouter(MenuContainer)



// WEBPACK FOOTER //
// ./src/views/misc/MenuContainer.jsx